module.exports = __webpack_public_path__ + "img/ai-chat.8a7c8025.jpg";